import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "../../config/config.service";
import { EnquiryRequest, FranchiseEnquiryRequest } from "../models/enquiry.model";
import { FeedbackDetails } from "../models/feedback.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class WebsiteService {
    private baseUrl!: string;

    constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
     this.baseUrl = this.configService.get().END_POINT;
   }

   sendEnquiry(enquiry: EnquiryRequest): Observable<any> {
    const headers = new HttpHeaders({
      'APP_FLAVOUR': window.location.hostname
    });
    return this.http.post(`${this.baseUrl}/auth/send-enquiry`, enquiry, { headers });
   }

   sendFranchiseEnquiry(enquiry: FranchiseEnquiryRequest): Observable<any> {
    const headers = new HttpHeaders({
      'APP_FLAVOUR': window.location.hostname
    });
    return this.http.post(`${this.baseUrl}/auth/send-franchise-enquiry`, enquiry, { headers });
   }

   saveFeedback(feedback: FeedbackDetails): Observable<any> {
    const headers = new HttpHeaders({
      'APP_FLAVOUR': window.location.hostname
    });
    return this.http.post(`${this.baseUrl}/api/feedbackDetails/save`, feedback, { headers });
   }

   getActiveFeedbacks(): Observable<FeedbackDetails[]> {
    const headers = new HttpHeaders({
      'APP_FLAVOUR': window.location.hostname
    });
    // This will fetch feedback where contentShow is "Yes"
    return this.http.get<FeedbackDetails[]>(`${this.baseUrl}/api/feedbackDetails/getAllContentShowYes`, { headers });
   }

}